import { parseHtmlContent } from '../utils';

export const renderHeader = (element) => {
  return {
    text: parseHtmlContent(element.content) || element.text || '',
    style: 'header',
    margin: [0, 15, 0, 6]
  };
};

export const renderLineBreak = () => {
  return {
    table: {
      widths: ['*'],
      body: [
        [
          {
            text: '',
            border: [false, false, false, true],
            borderColor: ['', '', '', '#CCCCCC']
          }
        ]
      ]
    },
    layout: {
      hLineWidth: () => 1,
      vLineWidth: () => 0,
      hLineColor: () => '#CCCCCC',
      paddingLeft: () => 0,
      paddingRight: () => 0,
      paddingTop: () => 0,
      paddingBottom: () => 0
    },
    margin: [0, 8, 0, 8]
  };
};

export const renderLabel = (element) => {
  return {
    text: parseHtmlContent(element.content) || element.text || '',
    style: 'label',
    margin: [0, 15, 0, 8]
  };
};

export const renderParagraph = (element) => {
  return {
    text: parseHtmlContent(element.content) || element.text || '',
    style: 'paragraph',
    margin: [0, 15, 0, 8]
  };
};

export const renderStaticImage = async (element) => {
  if (element.src) {
    if (element.src.startsWith('data:')) {
      return {
        image: element.src,
        width: 400,
        margin: [0, 15, 0, 0]
      };
    }

    try {
      const response = await fetch(element.src);
      const blob = await response.blob();

      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve({
            image: reader.result,
            width: 400,
            margin: [0, 15, 0, 0]
          });
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Failed to load image:', error);
      return {
        text: 'Failed to load image',
        style: 'placeholder',
        margin: [0, 15, 0, 0]
      };
    }
  }

  return null;
};

export const renderHyperLink = (element) => {
  return {
    text: [
      {
        text: element.content || element.text || '',
        link: element.href || '#',
        color: '#0066cc',
        decoration: 'underline'
      }
    ],
    margin: [0, 15, 0, 0]
  };
};
